import { forwardRef, useContext, useEffect } from 'react';
import { generateHexColor, translateX } from 'utils/helpers';
import axiosService from 'services/axiosService';
import appService from 'services/appService';
import { Col, Modal, Row } from 'antd';
import {
  JarvislyFormContext,
  JarvislyFormProvider,
  JarvislyInput,
} from 'components/jarvisly-components/others/FormComponents';
import { ROW_GUTTER } from 'constants/ThemeConstant';
import { TagOutlined } from '@ant-design/icons';

const modalName = 'BrandsModal';

// COMPONENT *******************************************************************
// *****************************************************************************
const ModalComponent = props => {
  // providers context ---------------------------------------------------------
  const { form } = useContext(JarvislyFormContext);

  // props deconstruction ------------------------------------------------------
  const {
    setSelectedRecord,
    selectedRecord,
    isUpdating,
    setIsUpdating,

    showModalLevel,
    setShowModalLevel,
  } = props;

  // local variables I ----------------------------------------------------------
  const title = !selectedRecord?._id
    ? translateX('new_brand')
    : translateX('edit_brand');

  // component states -----------------------------------------------------------

  // local variables II ---------------------------------------------------------

  // hooks ---------------------------------------------------------------------
  useEffect(() => {
    if (selectedRecord && showModalLevel(modalName)) {
      form?.setFieldsValue(selectedRecord);
    }
  }, [selectedRecord, showModalLevel(modalName), form]); // eslint-disable-line react-hooks/exhaustive-deps

  // METHODS -------------------------------------------------------------------
  const onClose = () => {
    setShowModalLevel(modalName, false);
  };

  const afterClose = () => {
    form.resetFields();
    setSelectedRecord(null);
    setIsUpdating(false);
  };

  // local variables III --------------------------------------------------------

  // UI COMPONENT --------------------------------------------------------------
  return (
    <>
      <Modal
        // className="title-fixed-with-18 modal-top"
        title={
          <>
            <TagOutlined />
            <span className="ml-2">{title}</span>
          </>
        }
        destroyOnHidden={true}
        open={showModalLevel(modalName)}
        okText={translateX('save')}
        onCancel={onClose}
        cancelText={translateX('close')}
        cancelButtonProps={{ style: { display: 'none' } }}
        onOk={() => form.submit()}
        getContainer={false}
        okType={'primary'}
        confirmLoading={isUpdating}
        afterClose={afterClose}
      >
        <Row gutter={ROW_GUTTER} justify={'space-between'}>
          {/* LABEL */}
          <Col span={24}>
            <JarvislyInput name="label" disabled={false} />
          </Col>
          {/* LABEL */}
        </Row>
      </Modal>
    </>
  );

  // INTERNAL FUNCTIONS ========================================================
  // ===========================================================================
};

// MAIN COMPONENT **************************************************************
// *****************************************************************************
const BrandsModal = forwardRef((props, ref) => {
  // providers context ---------------------------------------------------------

  // props deconstruction ------------------------------------------------------
  const {
    parameters,
    selectedRecord,
    refreshParameters,
    setIsUpdating,
    setShowModalLevel,
    setIsUpdated,
  } = props;

  // local variables I ---------------------------------------------------------

  // component states ----------------------------------------------------------

  // local variables II --------------------------------------------------------

  // hooks ---------------------------------------------------------------------

  // METHODS -------------------------------------------------------------------
  const onConfirm = async ({ body }) => {
    setIsUpdating(true);

    // color
    if (body?.backColor?.toHexString) {
      body.backColor = body.backColor?.toHexString();
    }
    if (!body.backColor) body.backColor = '#b9bcc4';
    body.foreColor = generateHexColor(body.backColor, true);
    body._id = selectedRecord?._id;

    const axiosOptions = {
      url: `/v1/products/parameters/add-to-set/${parameters?.productsParameters?._id}/$push/brands`,
      data: body,
    };

    appService.message('s', 'saved_parameters', 'onSave');
    await axiosService.put(axiosOptions);

    setIsUpdated(true);
    setShowModalLevel(modalName, false);
    refreshParameters(true);

    return body;
  };

  // variables III -------------------------------------------------------------

  // UI COMPONENT --------------------------------------------------------------
  return (
    <>
      <JarvislyFormProvider
        document={selectedRecord}
        requiredFields={['label']}
        showSubmitButton={false}
        onConfirm={onConfirm}
        autoFocus="label"
        abortComponentSave={true}
      >
        <ModalComponent {...props} />
      </JarvislyFormProvider>
    </>
  );
});

export default BrandsModal;
